module.exports = __webpack_public_path__ + "img/fixedPlane.d27d95c1.png";